<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <data-tag-sidebar :isSidebarActive="addTagDataSidebar" @getdata="getdata" @closeSidebar="toggleTagSidebar" :data="sidebarTagData" />

   <div >
   <vs-button class="user_add_btn" type="filled" @click.native="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Template</vs-button>
      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    </div>
    <vs-table ref="table" search pagination :max-items="itemsPerPage"  :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th>tag</vs-th>
        <vs-th></vs-th>
         <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td >
                <router-link :to="'/newsletters/temp/'+tr.id" class="text-inherit flex">
                <img :src="tr.image"  alt="" height="120px" width="100px" style="border:1px solid black; padding: 5px;">
                <p class="product-name font-medium truncate flex justify-center items-center ml-5">{{ tr.name }}</p>
                  </router-link>
              </vs-td>
              <vs-td>
              <div v-for="item in tr.tag" :key="item.id">
                <vs-chip @click="deleteTag(item)"  closable>{{item.name}}</vs-chip>
              </div>
              <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <vs-button  class="text-center" @click.native="editTagData(tr)"  size="small" icon-pack="feather" >Add new</vs-button>
               </vs-col>
               </vs-row>
              </vs-td>
              <vs-td><span @click="loadTemplate(tr.id)"><vs-chip color="primary">Use Template</vs-chip></span></vs-td>
             <vs-td class="whitespace-no-wrap">
                  <feather-icon  icon="EditIcon" @click="editData(tr)" svgClasses="h-4 w-4" class="mr-2"/>
                  <feather-icon icon="TrashIcon" @click="confirmDeleteRecord(tr)" svgClasses="h-4 w-4" class="mr-2 "/>
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-4 h-4 hover:text-primary stroke-current"  icon="DownloadIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item>
                <span class="flex items-center"  @click="DownloadPdf(tr)"> Download PDF
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center"  @click="DownloadJPEG(tr)">Download JPEG</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import DataTagSidebar from './DataTagSidebar.vue'
import {ALL_TEMPLATES, REMOVE_TEMPLATE, EDIT_NEWSLETTER_TEMPLATE, DOWNLOAD_TICKET_ATTACHMENT, SINGLE_NEWSLETTER, REMOVE_TEMPLATE_TAG} from '@/graphql'
export default {
  components: {
    DataViewSidebar,
    DataTagSidebar
  },
  data () {
    return {
      DeletedItem:null,
      templates:[],
      activeLoading :false,
      //   {
      //   "name":"Template 1",
      //   "link":"/newsletters/temp1"
      //   },
      //   {
      //   "name":"Template 2",
      //    "link":"/newsletters/temp2"
      //   },
      //  {
      //   "name":"Template 3",
      //    "link":"/newsletters/temp3"
      //   },
      // ],
      selected: [],
      // products: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      role:null,
      addTagDataSidebar: false,
      sidebarTagData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    products () {
      return this.templates
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    deleteTag (item) {
      this.$apollo
        .mutate({
          mutation: REMOVE_TEMPLATE_TAG,
          variables: {
            id:   item.id,  
            tag:  item.name
          }
        })
        .then(response => {
          this.get()
          if (response.data.removeTemplateTag.status == 'Success') {
            this.StatusSuccess(response.data.removeTemplateTag.message, response.data.removeTemplateTag.color)
          } else {
            this.StatusFail()
          }
        }).catch(error => {
          console.log(error)
          this.StatusFail()
        })
    },
    loadTemplate (id) {
      this.$apollo
        .mutate({
          mutation: SINGLE_NEWSLETTER,
          variables: {
            id
          }
        })
        .then((response) => {
          if (response) {
            this.$store.dispatch('setNewsletterJson', response.data.newsletter.template)
            this.$router.push('/newsletter/new')
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    DownloadPdf (data) {
      this.$apollo
        .mutate({
          mutation: DOWNLOAD_TICKET_ATTACHMENT,
          variables: {
            file:`newsletters/P${data.key  }.pdf`
          }
        })
        .then(response => {
          window.location = response.data.downloadTicketAttachment
          this.get()
        }
        )
    },
    DownloadJPEG (data) {
      this.$apollo
        .mutate({
          mutation: DOWNLOAD_TICKET_ATTACHMENT,
          variables: {
            file:`newsletters/${data.key  }.jpeg`
          }
        })
        .then(response => {
          window.location = response.data.downloadTicketAttachment
          this.get()
        }
        )
    },
    MarkAsTemplate (tr) {
      this.$apollo
        .mutate({
          mutation: EDIT_NEWSLETTER_TEMPLATE,
          variables: {
            id:tr.id,  
            name:  tr.name,
            is_temp: !tr.is_temp
          }
        })
        .then(response => {
          if (response.data.editNewsletterTemplate.status === 'Success') {
            this.get()
            this.StatusSuccess(response.data.editNewsletterTemplate.message, response.data.editNewsletterTemplate.color)
          } else {
            this.StatusFail()
          }
        }).catch(error => {
          console.log(error)
          this.StatusFail()
        })
    },
    StatusFail () {
      this.$vs.notify({
        title: 'Template',
        text: 'Failed to Update',
        color: 'success',
        position: 'top-right'
      })
    },
    getdata () {
      this.get()
    },
    addNewData () {
      this.$router.push({ path: '/newsletter/temp/new' })
      // this.sidebarData = {}
      // this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    editTagData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarTagData = data
      this.toggleTagSidebar(true)
    },
    toggleTagSidebar (val = false) {
      this.addTagDataSidebar = val
    },
    confirmDeleteRecord (template) {
      this.DeletedItem = template
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${template.name} "`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.$apollo
        .mutate({
          mutation: REMOVE_TEMPLATE,
          variables: {
            id:  this.DeletedItem.id
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteNewsletterTemplate.state === 'Success') {
            this.StatusSuccess(response.data.deleteNewsletterTemplate.message, response.data.deleteNewsletterTemplate.color)
          }
        }).catch(error => {
          console.log(error)
        })
    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: 'Template',
        text: status,
        color,
        position: 'top-right'
      })
    },
    loader () {
      this.activeLoading = true
      this.$vs.loading({
        type:'sound'
      })
    },
    get () {
      this.$apollo
        .mutate({
          mutation: ALL_TEMPLATES
        })
        .then(response => {
          this.templates = response.data.templates
          this.activeLoading = false
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.loader()
    this.get()
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    this.role = userRoles[0]['name']
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

